import { PermissionCategory } from "../../http/protocol";
import { UserStoreState } from "../../user/UserStore";

// The permission map encodes write access as true and read-only access as false, so mere
// presence of the key is what grants access — the same as accessLevel="r" elsewhere.
export function hasAiChatPermission(permissions: UserStoreState["permissions"]): boolean {
  return permissions?.[PermissionCategory.AI_CHAT] != null;
}
